// extracted by mini-css-extract-plugin
module.exports = {"container":"Pp-z","list":"Qp-z"};